module.exports = __webpack_public_path__ + "img/kkam_detail.cd4879aa.jpg";